import uuid from "node-uuid";
import "../../../Events.js";
import "./Leaflet/Base";
import "./OL3/Base";

/** @namespace GIS.Map.Layer */
NS("GIS.Map.Layer");

/**
 * @class
 * @extends Events
 */
GIS.Map.Layer.Base = Class(Events, /** @lends GIS.Map.Layer.Base.prototype */ {
    vendors: {
        "leaflet": GIS.Map.Layer.Leaflet.Base,
        "ol3": GIS.Map.Layer.OL3.Base
    },
    /**
     * @type {GIS.Map.Base}
     * @protected
     */
    map: null,
    /**
     * @protected
     * @type {Object}
     */
    layer: null,
    /**
     * @type {{id:(number|string)}}
     */
    data: null,
    // options
    title: null,
    /** @type {string} unique layer name */
    name: null,
    opacity: 1,
    attributions: [],
    minZoom: null,
    maxZoom: null,
    visibility: true,
    /** @type {string} */
    projection: null,
    filter_: null,
    /**
     * @param {GIS.Map.Base} map
     * @param {Object} [options]
     */
    initialize(map, options) {
        this.map = map;
        options = this.prepareOptions(
            _.merge({
                    name: uuid.v4()
                },
                Util.pickOptions(
                    this,
                    this.optionsNames()
                ),
                Util.pickOptions(
                    options,
//                    this.optionsNames()
                    _.keys(options)
                )
            )
        );
        _.merge(this, options);

        this.layer = this.createLayer(options);
        this.layer.on("refresh", this.onLayerRefresh, this);

        this.style = this.layer.style;
    },
    /**
     * @returns {string[]}
     */
    optionsNames() {
        return ["name", "title", "attributions", "minZoom", "maxZoom", "opacity", "projection", "visibility", "filter_"];
    },
    /**
     * @param {Object} options
     * @returns {Object} options
     * @protected
     */
    prepareOptions(options = {}) {
        return options;
    },
    /**
     * @fires GIS.Map.Layer.Base#before.destroy
     * @fires GIS.Map.Layer.Base#destroy
     * @returns {GIS.Map.Layer.Base}
     */
    destroy() {
        this.emit("before.destroy");

        if (this.layer) {
            this.layer.destroy();
            this.layer = null;
        }

        this.map = null;

        this.emit("destroy").off();

        return this;
    },
    /**
     * @param {Object} [options]
     * @returns {*}
     * @protected
     */
    createLayer(options) {
        var layerClass = this.vendors[ this.map.vendor ];
        var layer = null;

        if (layerClass) {
            switch (this.map.vendor) {
                case "leaflet":
                case "ol3":
                default:
                    layer = new layerClass(this.map, this, options);
                    break;
            }
        }

        this.layer = layer;

        return layer;
    },
    /**
     * @returns {GIS.Map.Layer.Base}
     * @fires GIS.Map.Layer.Base#show
     */
    show() {
        this.layer.show();

        this.emit("show");

        return this;
    },
    /**
     * @returns {GIS.Map.Layer.Base}
     * @fires GIS.Map.Layer.Base#hide
     */
    hide() {
        this.layer.hide();

        this.emit("hide");

        return this;
    },
    /**
     * @returns {boolean}
     */
    visible() {
        return this.layer.visible();
    },
    /**
     * @param {boolean} visible
     * @returns {GIS.Map.Layer.Base}
     */
    toggle(visible) {
        if (!Util.isDefined(visible)) {
            visible = !this.visible();
        }

        if (visible) {
            this.show();
        } else {
            this.hide();
        }

        return this;
    },
    /**
     * @param {number} opacity
     * @returns {GIS.Map.Layer.Base}
     */
    setOpacity(opacity) {
        this.layer.setOpacity(opacity);

        return this;
    },
    /**
     * @returns {number}
     */
    getOpacity() {
        return this.layer.getOpacity();
    },
    /**
     * @returns {*}
     */
    getAdapter() {
        return this.layer;
    },
    /**
     * @returns {*}
     */
    getVendor() {
        return this.layer.getVendor();
    },
    /**
     * @returns {*}
     */
    getType() {},
    /**
     * Updates and redraws layer.
     * @returns {GIS.Map.Layer.Base}
     */
    refresh(...args) {
        this.layer.refresh(...args);

        return this;
    },
    /**
     * @fires GIS.Map.Layer.Base#refresh
     * @protected
     */
    onLayerRefresh() {
        /**
         * @event GIS.Map.Layer.Base#refresh
         */
        this.emit("refresh");
    },
    /**
     * Adds Popup overlay on map.
     *
     * @param {string|Element} content
     * @param {number[]} coordinate
     * @param {Object} [options] Additional data for popup
     * @returns {*}
     */
    openPopup(content, coordinate, options) {
        return this.layer.openPopup(content, coordinate, options);
    },
    /**
     * Closes popup by name and removes it if needed
     *
     * @param {*} popup Popup object
     * @returns {*}
     */
    closePopup(popup) {
        return this.layer && this.layer.closePopup(popup);
    },
    /**
     * Base method to load feature data. Should be overridden in child classes
     *
     * @param {number[]} coordinate
     * @param {Object} [options] Additional options
     * @returns {Promise.<Object>}
     */
    loadFeatureData(coordinate, options) {
        return this.layer.loadFeatureData(coordinate, options);
    },
    /**
     * @param {Object} options
     * @returns {GIS.Map.Layer.Base}
     */
    updateOptions(options) {
        const keys = _.keys(options);
        options = Util.pickOptions(this.prepareOptions(options), keys);
//        options = this.prepareOptions(Util.pickOptions(options, this.optionsNames()));
        _.assign(this, options);
        this.layer.updateOptions(options);

        return this;
    },
    /**
     * @param {Object|Function} filter
     */
    filter(filter) {
        this.filter_ = filter
        this.layer.filter(filter)
    }
});
